import {TextGeometry, TextGeometryParameters} from 'three/examples/jsm/geometries/TextGeometry';
import {Mesh} from "three";
import {Material} from "three/src/materials/Material";

type CreateTextProps = {
    text: string;
    materials: Material[];
} & TextGeometryParameters;

const fontMap: { [key: string]: number } = {

    'helvetiker': 0,
    // 'optimer': 1,
    // 'gentilis': 2,
    // 'droid/droid_sans': 3,
    // 'droid/droid_serif': 4

};

const weightMap: { [key: string]: number } = {

    'regular': 0,
    'bold': 1

};

const reverseFontMap: (string | null)[] = [];
const reverseWeightMap: (string | null)[] = [];

for (const i in fontMap) reverseFontMap[fontMap[i]] = i;
for (const i in weightMap) reverseWeightMap[weightMap[i]] = i;

export function createText({
                               text,
                               font,
                               size = 170,
                               materials,
                               height = 1,
                               bevelSize = 0.1,
                               bevelEnabled = true,
                               curveSegments = 4,
                               bevelThickness = 0.5,
                           }: CreateTextProps) {

    const textGeo = new TextGeometry(text, {
        font,
        size,
        height,
        curveSegments,
        bevelThickness,
        bevelSize,
        bevelEnabled,

    });

    textGeo.computeBoundingBox();

    const textMesh = new Mesh(textGeo, materials);

    textMesh.position.z = 0;

    textMesh.rotation.x = 0;
    textMesh.rotation.y = Math.PI * 2;

    (textMesh as any).textString = text;
    return textMesh
}
